
export interface DataFormat {
	lines: {
		parts: any[],
		separator?: string,
	}[],
}

export function formatData(format: DataFormat | undefined) {
	const result = [];

	if (!format) {
		return <div><i>Not entered</i></div>;
	}

	let i = 0;
	for(let l of format.lines) {
		const line = [];
		
		for(let p of l.parts) {
			if (p !== undefined) line.push(p);
		}

		result.push(
			<div key={i}>{line.join(l.separator ? l.separator : "")}</div>
		)

		i++;
	}

	return <>{result}</>;
}
